module.exports = __webpack_public_path__ + "static/media/em-50.970f4da9.png";